var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DomTree_1;
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { AUTO_COMPONENT_ID_PREFIX } from "../../../../../../lib/utils/consts";
import NestedDraggable from 'vuedraggable';
import devToolMixin from '../../../util/devToolMixin';
import { keyBy } from "lodash-es";
import CompPopover from "./CompPopover";
import { getVNodeFactoryState } from "../../../../../../lib/renderer/utils";
let DomTree = DomTree_1 = class DomTree extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.selected = false;
    this.copied = false;
  }
  get expanded() {
    return this.expandedLUT[this.currentCompPath];
  }
  set expanded(val) {
    this.bus.$set(this.bus.layoutOpts.expandedLUT, this.currentCompPath, val);
  }
  /** ********/
  mounted() {
    this.bus.$on('toggleExpand', val => {
      if (this.bus.activeCompInfo.compPath === this.currentCompPath) {
        this.expanded = val;
      }
    });
    this.selected = this.currentCompPath === '';
    this.expanded = this.currentCompPath === '';
  }
  handleActiveCompPathChange(val) {
    if (val === this.currentCompPath) {
      this.selected = true;
      this.$emit('childSelected');
    } else {
      this.selected = false;
    }
  }
  handleSelectComp() {
    if (this.selected) {
      this.bus.$set(this.bus, 'activeCompInfo', {
        layout: this.layout,
        compPath: this.currentCompPath,
        siblingsNum: this.siblingsNum,
        slotSiblings: this.slotSiblings
      });
      this.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
      if (!this.isDesignMode) {
        this.dtHightLightRect(null);
      }
    }
  }
  handleCurrentScopedSlotIndexChange() {
    this.dtHightLightRect(null);
  }
  // ultpagelet应该已经被更新过了
  handlePageletChange() {
    if (this.activeCompPath === this.currentCompPath) {
      this.selected = true;
    } else {
      this.selected = false;
    }
  }
  /** *** Getters *****/
  get isSearchCandidate() {
    return this.candidateCompPaths.includes(this.currentCompPath);
  }
  get meta() {
    var _this$uc$components$t;
    return (_this$uc$components$t = this.uc.components[this.layout.type]) === null || _this$uc$components$t === void 0 ? void 0 : _this$uc$components$t.meta;
  }
  get tagName() {
    const showCn = this.bus.options.showCnName;
    return showCn ? this.uc.getLayoutName(this.layout) : this.layout.type;
  }
  get tagProps() {
    const propsArr = [];
    if (this.layout.componentId && !this.layout.componentId.startsWith(AUTO_COMPONENT_ID_PREFIX)) {
      propsArr.push(`id="${this.layout.componentId}"`);
    }
    return propsArr.join(' ');
  }
  get children() {
    var _this$layout;
    return ((_this$layout = this.layout) === null || _this$layout === void 0 ? void 0 : _this$layout.children) || [];
  }
  set children(val) {
    this.$set(this.layout, 'children', val);
    this.uc.notifyPageletsChange(0);
  }
  get slots() {
    var _this$layout2;
    if ((_this$layout2 = this.layout) !== null && _this$layout2 !== void 0 && _this$layout2.slots) return Object.entries(this.layout.slots).map(([key, value]) => ({
      type: key,
      children: value
    }));
    return [];
  }
  set slots(val) {
    this.$set(this.layout, 'slots', keyBy(val, 'type'));
    this.uc.notifyPageletsChange(0);
  }
  get scopedSlots() {
    var _this$layout3, _this$layout6;
    if (((_this$layout3 = this.layout) === null || _this$layout3 === void 0 ? void 0 : _this$layout3.type) === 'public-w-list-filter') {
      var _this$layout4;
      const checkedList = Object.keys((_this$layout4 = this.layout) === null || _this$layout4 === void 0 || (_this$layout4 = _this$layout4.props) === null || _this$layout4 === void 0 ? void 0 : _this$layout4.filter).filter(key => {
        var _this$layout5;
        return (_this$layout5 = this.layout) === null || _this$layout5 === void 0 || (_this$layout5 = _this$layout5.props) === null || _this$layout5 === void 0 ? void 0 : _this$layout5.filter[key].checked;
      });
      return Object.entries(this.layout.scopedSlots).map(([key, value]) => ({
        type: key,
        layout: value.layout
      })).filter(({
        type
      }) => checkedList.includes(type));
    }
    if ((_this$layout6 = this.layout) !== null && _this$layout6 !== void 0 && _this$layout6.scopedSlots) return Object.entries(this.layout.scopedSlots).map(([key, value]) => ({
      type: key,
      layout: value.layout
    }));
    return [];
  }
  set scopedSlots(val) {
    this.$set(this.layout, 'scopedSlots', keyBy(val, 'type'));
    this.uc.notifyPageletsChange(0);
  }
  get isContainer() {
    var _this$meta, _this$meta2;
    return ((_this$meta = this.meta) === null || _this$meta === void 0 ? void 0 : _this$meta.category) === '容器' || ((_this$meta2 = this.meta) === null || _this$meta2 === void 0 ? void 0 : _this$meta2.category) === '布局' || this.children.length > 0 || Object.keys(this.layout.scopedSlots || {}).length > 0 || Object.keys(this.layout.slots || {}).length > 0;
  }
  get expandable() {
    return this.children.length > 0 || this.slots.length > 0;
  }
  get dataStub() {
    return this.designer.getDataStubOfRenderer();
  }
  get isDesignMode() {
    return !!this.uc.designer;
  }
  /** *** Methods *****/
  stringifyCompProps(props) {
    return Object.entries(props || {}).map(el => `${el[0]}=${el[1]}`);
  }
  toggleExpansion() {
    this.expanded = !this.expanded;
  }
  handleMouseEnter() {
    var _this$designer;
    (_this$designer = this.designer) === null || _this$designer === void 0 || _this$designer.setHighlight(this.currentCompPath, 'normal');
  }
  handleMouseLeave() {
    var _this$designer2;
    (_this$designer2 = this.designer) === null || _this$designer2 === void 0 || _this$designer2.setHighlight(this.currentCompPath, false);
  }
  handleDomCopy() {
    this.copied = true;
    this.handleCopyActive();
    setTimeout(() => {
      this.copied = false;
    }, 1000);
  }
  handleDrag(key, val) {
    this.$set(this.layout.slots, key, val);
    this.uc.notifyPageletsChange(0);
  }
  handleDragChange(e, typeName = 'default') {
    const {
      added,
      removed,
      moved
    } = e;
    if (moved) {
      // 在同级的情况下，区分向上拖拽和向下拖拽
      const {
        oldIndex,
        newIndex
      } = moved;
      const dragUp = oldIndex > newIndex;
      this.bus.$set(this.bus.layoutOpts, 'dragInfo', {
        fromPath: `${this.currentCompPath}/${typeName}/${oldIndex}`,
        toPath: `${this.currentCompPath}/${typeName}/${dragUp ? newIndex : newIndex + 1}`,
        prevPath: `${this.currentCompPath}/${typeName}/${newIndex}`
      });
    } else if (added) {
      this.bus.$set(this.bus.layoutOpts.dragInfo, 'toPath', `${this.currentCompPath}/${typeName}/${added.newIndex}`);
    } else if (removed) {
      this.bus.$set(this.bus.layoutOpts.dragInfo, 'fromPath', `${this.currentCompPath}/${typeName}/${removed.oldIndex}`);
    } else {
      console.error('拖拽失败');
    }
  }
  addScope(type) {
    var _this$currentScope;
    const factoryState = getVNodeFactoryState(((_this$currentScope = this.currentScope) === null || _this$currentScope === void 0 || (_this$currentScope = _this$currentScope.list) === null || _this$currentScope === void 0 ? void 0 : _this$currentScope[this.currentScope.index]) || this.uc.renderer, this.currentCompPath);
    const list = factoryState === null || factoryState === void 0 ? void 0 : factoryState.getScopedSlotInstances(type);
    this.$set(this.bus, 'scopedSlotStack', [...this.bus.scopedSlotStack, {
      index: 0,
      list,
      type,
      compPath: this.currentCompPath
    }]);
  }
  renderOpenTag() {
    return this.renderLeaf();
  }
  renderChildren() {
    const h = this.$createElement;
    const {
      scopedSlots,
      slots,
      children,
      depth,
      expanded
    } = this;
    const {
      options
    } = this.bus;
    return h("div", {
      "directives": [{
        name: "show",
        value: expanded
      }]
    }, [scopedSlots.map(scopedSlot => h("div", {
      "class": "ucd-domTree-scopedSlot",
      "on": {
        "click": () => this.addScope(scopedSlot.type)
      }
    }, [h("a-tooltip", {
      "attrs": {
        "getPopupContainer": () => {
          var _this$windowRef;
          return ((_this$windowRef = this.windowRef) === null || _this$windowRef === void 0 ? void 0 : _this$windowRef.document.body) || window.document.body;
        }
      }
    }, [h("span", {
      "slot": "title"
    }, [" \u8FDB\u5165\u5B50\u9875\u9762\u7247 "]), h("a-icon", {
      "attrs": {
        "type": "select"
      }
    })]), h("span", {
      "class": "ucd-domTree-scopedSlot-title"
    }, [`$${this.bus.options.showCnName ? '作用域插槽' : 'scopedSlot'} : ${scopedSlot.type}`])])), slots.map(slot => h("div", {
      "class": "ucd-domTree-slot"
    }, [h("div", {
      "class": "ucd-domTree-slot-title"
    }, [" ", `$${this.bus.options.showCnName ? '插槽' : 'slot'} : ${slot.type}`, " "]), h("nested-draggable", {
      "attrs": {
        "value": slot.children,
        "animation": 150,
        "group": "domTreeGroup"
      },
      "on": {
        "change": e => this.handleDragChange(e, slot.type)
      }
    }, [slot.children.map((eachSlot, index) => {
      if (!!eachSlot) {
        return h(DomTree_1, {
          "attrs": {
            "siblingsNum": slot.children.length,
            "layout": eachSlot,
            "current-comp-path": `${this.currentCompPath}/${slot.type}/${index}`,
            "depth": depth + 1,
            "options": options,
            "hideActions": this.hideActions,
            "slotSiblings": slots.map(slot => slot.type),
            "fromAside": this.fromAside
          },
          "class": "ucd-domTree-subTree inSlot",
          "key": `${eachSlot.type}-${index}`,
          "on": {
            "childSelected": () => {
              this.expanded = true;
              this.$emit('childSelected');
            }
          }
        });
      }
      return null;
    })])])), h("nested-draggable", {
      "attrs": {
        "value": children,
        "animation": 150,
        "group": "domTreeGroup"
      },
      "on": {
        "change": this.handleDragChange
      }
    }, [children.map((child, index) => {
      if (!!child) {
        return h(DomTree_1, {
          "attrs": {
            "siblingsNum": children.length,
            "layout": child,
            "current-comp-path": `${this.currentCompPath}/default/${index}`,
            "depth": depth + 1,
            "options": options,
            "hideActions": this.hideActions,
            "fromAside": this.fromAside
          },
          "class": "ucd-domTree-subTree",
          "key": `${child.type}-${index}`,
          "on": {
            "childSelected": () => {
              this.expanded = true;
              this.$emit('childSelected');
            }
          }
        });
      }
      return null;
    })])]);
  }
  renderCollapsed() {
    const h = this.$createElement;
    return;
    const {
      expanded,
      layout
    } = this;
    if (!expanded && layout.children && layout.children.length) {
      return h("div", {
        "class": "ucd-domTree-collapsed",
        "on": {
          "click": this.toggleExpansion
        }
      }, ["..."]);
    }
  }
  // 因为存在拖入children的逻辑，为了交互，给一个关闭
  renderCloseTag() {
    const h = this.$createElement;
    const {
      selected,
      tagName
    } = this;
    return h("div", {
      "class": `ucd-domTree-row ${selected && 'selected'}`,
      "attrs": {
        "tabindex": "0"
      },
      "on": {
        "mouseenter": this.handleMouseEnter,
        "mouseleave": this.handleMouseLeave,
        "mousedown": () => this.$set(this, 'selected', true)
      }
    }, [h("span", {
      "class": "ucd-domTree-nodeName closing"
    }, ["< ", h("span", {
      "class": "ucd-domTree-nodeName-tagName"
    }, [" ", `/${tagName}`, " "]), " >"])]);
  }
  renderContainer() {
    const content = [this.renderOpenTag(), this.renderChildren(), this.renderCollapsed()
    // this.renderCloseTag()
    ];
    return content;
  }
  renderLeaf() {
    const h = this.$createElement;
    const {
      selected,
      expanded,
      tagName,
      tagProps,
      isSearchCandidate,
      fromAside
    } = this;
    return h("div", {
      "class": `ucd-domTree-row ${selected ? 'selected' : ''} ${!fromAside && isSearchCandidate ? 'candidate' : ''}`,
      "on": {
        "dblclick": this.toggleExpansion,
        "mouseenter": this.handleMouseEnter,
        "mouseleave": this.handleMouseLeave,
        "mousedown": () => this.$set(this, 'selected', true)
      }
    }, [this.isContainer && h("a-icon", {
      "attrs": {
        "type": expanded ? 'caret-down' : 'caret-right'
      },
      "class": "ucd-domTree-row-arrow",
      "on": {
        "click": this.toggleExpansion
      }
    }), h("span", {
      "class": "ucd-domTree-row-container"
    }, [h("span", {
      "class": "ucd-domTree-nodeName"
    }, ["<", h("span", {
      "class": "ucd-domTree-nodeName-tagName"
    }, [tagName, " "]), h("span", {
      "class": "ucd-domTree-nodeName-props"
    }, ["\xA0", tagProps, " "]), ">"]), selected && this.bus.options.showActions && !this.hideActions && h("span", {
      "class": "ucd-devTool-iconBtns"
    }, [!!this.isDesignMode && h(CompPopover), this.copied ? h("a-icon", {
      "on": {
        "mouseleave": () => setTimeout(() => this.copied = false, 500)
      },
      "attrs": {
        "type": "check-circle",
        "theme": "twoTone",
        "two-tone-color": "#52c41a"
      }
    }) : h("a-tooltip", {
      "attrs": {
        "getPopupContainer": () => {
          var _this$windowRef2;
          return ((_this$windowRef2 = this.windowRef) === null || _this$windowRef2 === void 0 ? void 0 : _this$windowRef2.document.body) || window.document.body;
        }
      }
    }, [h("span", {
      "slot": "title"
    }, [" \u590D\u5236\u7ED3\u6784\u5230\u526A\u5207\u677F "]), h("a-icon", {
      "attrs": {
        "theme": "filled",
        "type": "copy"
      },
      "on": {
        "click": this.handleDomCopy
      }
    })]), !!this.isDesignMode && h("a-icon", {
      "attrs": {
        "theme": "filled",
        "type": "delete"
      },
      "on": {
        "click": this.handleDeleteActive
      }
    })])])]);
  }
  render() {
    const h = arguments[0];
    const {
      expanded,
      expandable,
      isContainer
    } = this;
    return h("div", {
      "class": `ucd-domTree ${expanded ? 'expanded' : ''}`
    }, [h("div", {
      "class": "ucd-domTree-nodeContainer"
    }, [expandable || isContainer && expanded ? this.renderContainer() : this.renderLeaf()])]);
  }
};
__decorate([Prop({
  type: Object,
  default: () => ({})
})], DomTree.prototype, "layout", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], DomTree.prototype, "depth", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], DomTree.prototype, "currentCompPath", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], DomTree.prototype, "siblingsNum", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], DomTree.prototype, "hideActions", void 0);
__decorate([Prop({
  type: Array,
  default: () => []
})], DomTree.prototype, "slotSiblings", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], DomTree.prototype, "fromAside", void 0);
__decorate([Watch('activeCompPath')], DomTree.prototype, "handleActiveCompPathChange", null);
__decorate([Watch('selected')], DomTree.prototype, "handleSelectComp", null);
__decorate([Watch('currentScopedSlotIndex')], DomTree.prototype, "handleCurrentScopedSlotIndexChange", null);
__decorate([Watch('ultPagelet')], DomTree.prototype, "handlePageletChange", null);
DomTree = DomTree_1 = __decorate([Component({
  name: 'DomTree',
  components: {
    NestedDraggable
  }
})], DomTree);
export default DomTree;
//# sourceMappingURL=DomTree.js.map
